import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

const tabs = [{ slug: "all", name: "全部" }, ...categories.map((cat) => ({ slug: cat.slug, name: cat.name }))];

export default function LatestFeed() {
  const [active, setActive] = useState("all");

  const list = useMemo(() => {
    const source = active === "all" ? articles : articles.filter((item) => item.categorySlug === active);
    return [...source].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [active]);

  const shown = list.slice(0, 6);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl tracking-wide text-foreground-950 md:text-3xl">最新爆料</h2>
            <p className="mt-2 text-sm text-foreground-600">每天持续更新，越往下翻越有料。</p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.slug}
              type="button"
              onClick={() => setActive(tab.slug)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-1 py-1 text-sm transition-colors ${
                active === tab.slug ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 hover:bg-background-200"
              }`}
            >
              <span className="block rounded-full px-3 py-0.5">{tab.name}</span>
            </button>
          ))}
        </div>

        {shown.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {shown.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
            这个分类还没有爆料，换个方向看看？
          </p>
        )}

        <div className="mt-8 flex justify-center">
          <Link
            to={active === "all" ? "/search" : `/category/${active}`}
            className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}